/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import clsx from 'clsx'
import React from 'react'

import CloseIcon from '../../assets/img/ico-close-popup.svg?react'
import Spinner from '../Spinner'

interface ModalProps {
    isOpen: boolean
    onClose: () => void
    children: React.ReactNode
    title: string
    isLoading?: boolean
}

const Modal = ({
    isOpen,
    onClose,
    title,
    isLoading = false,
    children,
}: ModalProps) => {
    return (
        <div
            id="modal"
            className={clsx('modal modal-1', { 'modal--show': isOpen })}
            // onClick={onClose}
            onMouseDown={onClose}
        >
            <div
                className="modal__dialog modal__dialog--md"
                onClick={e => e.stopPropagation()}
                onMouseDown={e => e.stopPropagation()}
            >
                <div className="modal__content">
                    <div className="modal__header">
                        <p className="modal__header-title">{title}</p>
                        <a
                            href="#"
                            className="btn btn-close"
                            onClick={onClose}
                        >
                            <span className="ico">
                                <CloseIcon />
                            </span>
                        </a>
                    </div>
                    {isLoading ? (
                        <div className="modal__body p-0">
                            <div className="flex items-center justify-center min-h-300">
                                <Spinner />
                            </div>
                        </div>
                    ) : (
                        children
                    )}
                </div>
            </div>
        </div>
    )
}

export default Modal
